/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const visiblepopup = () => {
  const btnShow = document.querySelectorAll('.btn-popup-visible-js');
  const targetBtn = document.querySelector('.c-multisite-popup');

  // Skip if popup element doesn't exist (e.g., on sites 4 and 5 with city selector)
  if (!targetBtn) {
    return;
  }

  btnShow.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      if (targetBtn.classList.contains('is-active')) {
        targetBtn.classList.remove('is-active');
      } else {
        targetBtn.classList.add('is-active');
      }
    });
  });

  document.addEventListener('click', e => {
    if (e.target.classList.contains('c-multisite-popup')) {
      targetBtn.classList.remove('is-active');
    }
  });
};

export default visiblepopup;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/visiblepopup.js